import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import BreadCrumb from "@/components/BreadCrumb.vue";
import { useRouter } from "vue-router";
// import { ElAside } from 'element-plus'
export default {
  components: {
    BreadCrumb
    // ElAside
  },
  setup() {
    var _routers$find$childre;
    const menus = [{
      path: "/setting-center/operation",
      meta: {
        title: "运营点位管理",
        icon: require("@/assets/img/setting/position.png"),
        desc: "管理各渠道运营点位"
      }
    }, {
      path: "/setting-center/auth-mng/setting",
      meta: {
        title: "角色权限",
        icon: require("@/assets/img/setting/role.png"),
        desc: "管理角色及其权限"
      }
    }, {
      path: "/setting-center/type",
      meta: {
        title: "素材类型管理",
        icon: require("@/assets/img/setting/assets.png"),
        desc: "管理素材类型匹配"
      }
    }, {
      path: "/setting-center/tag",
      meta: {
        title: "标签管理",
        icon: require("@/assets/img/setting/tag.png"),
        desc: "管理素材关联标签"
      }
    }, {
      path: "/setting-center/account",
      meta: {
        title: "账号管理",
        icon: require("@/assets/img/setting/account.png"),
        desc: "管理账号、分配角色"
      }
    }, {
      path: "/setting-center/log",
      meta: {
        title: "日志管理",
        icon: require("@/assets/img/setting/log.png"),
        desc: "系统相关操作记录"
      }
    }, {
      path: "/setting-center/notice",
      meta: {
        title: "公告管理",
        icon: require("@/assets/img/setting/gonggao.png"),
        desc: "新增、管理公告"
      }
    }];
    const routers = useRouter().options.routes;
    console.log(routers);
    const settingMenus = (_routers$find$childre = routers.find(i => i.name === "main").children.find(j => j.name === "setting-center").children) !== null && _routers$find$childre !== void 0 ? _routers$find$childre : menus;
    return {
      settingMenus
    };
  }
};